<template>
<div class="chapter">
<div class="inner_page">
<blockquote class="sink epigraph">
<p class="left ">Without thinking of good or evil, show me your original face before your mother and father were born.—<em>Zen koan</em></p>
<p class="left spaceabove2">In abortion the person who is massacred, physically and morally, is the woman. For any man with a conscience every abortion is a moral ordeal that leaves a mark, but . . . every male should bite his tongue three times before speaking about such things.—<em>Italo Calvino</em></p>
</blockquote>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// front02.vue?9b88628e